// This device's registration (docs/pending/features.md 21): the window `devices` (one per Mac), the Mac's ⋯ ›
// Devices…, and the wire kind `devices` (ask → the Mac's list; the window listens on the link itself).
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'
import { registerWire } from '../../core/wire.js'
import { learnLinkedMacs } from '../../core/linked-macs.js'
import { heard as heardPush } from '../../core/webpush.js'

registerWindow('devices', { module: () => import('./devices.js'), css: 'windows/devices/devices.css', key: (a, key) => 'devices-' + (key || 'mac'), title: () => 'Devices', place: ['home', 'trailing'] })
registerHomeItem({ id: 'devices', label: 'Devices…', symbol: 'lucide:monitor-smartphone', needs: 'paired', section: 'mac', order: 25 })
// a linked Cody Mac holding this device (docs/research/pair-a-cody.md) joins this browser's Mac list
// — and the app's Mac list adopts it at once (app.js hears `cody:macs-learned`; macs.js adopt), not at the next launch
registerWire('devices', (link, payload, m) => {
  if (/^push(Key|Subscribe|Unsubscribe)$/.test(m?.t || '')) { heardPush(m); return }   // Web Push's answers (core/webpush.js)
  if (m?.t !== 'devices') return
  link.devices = m
  const added = m.macs ? learnLinkedMacs(m.macs) : []
  // every linked Mac it names, new or not: one its door refused tries again now (macs.js retryRefused)
  const named = (Array.isArray(m.macs) ? m.macs : []).map((x) => x?.room).filter((r) => typeof r === 'string')
  if ((added.length || named.length) && typeof CustomEvent === 'function') globalThis.dispatchEvent?.(new CustomEvent('cody:macs-learned', { detail: { added, named } }))
})
